import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-right/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import {ChatUserListComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import {FriendComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import {ChatMsgComponent} from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { NavForecastComponent } from './theme/layout/admin/nav-bar/nav-right/nav-forecast/nav-forecast.component';
import { NavLookupItemComponent } from './theme/layout/admin/nav-bar/nav-right/nav-lookup-item/nav-lookup-item.component';
import { NavSyncComponent } from './theme/layout/admin/nav-bar/nav-right/nav-sync/nav-sync.component';
import { NavLostSaleComponent } from './theme/layout/admin/nav-bar/nav-right/nav-lost-sale/nav-lost-sale.component';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {GlobalErrorHandler} from './core/misc/global-error-handler';
import {rollbarFactory, RollbarService} from './core/services/logging.service';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { ServerErrorInterceptor } from './core/interceptors/server-error.interceptor';
import { SessionInterceptor } from './core/interceptors/session.interceptor';
import { windowProvider, WindowToken } from './core/misc/window';
import { FormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from '@progress/kendo-angular-label';
import { NotificationBannerComponent } from './theme/layout/admin/notification-banner/notification-banner.component';
import { ForecastuiModule } from './theme/shared/forecastui/forecastui.module';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ChatUserListComponent,
    FriendComponent,
    ChatMsgComponent,
    ConfigurationComponent,
    NavForecastComponent,
    NavLookupItemComponent,
    NavSyncComponent,
    NavLostSaleComponent,
    NotificationBannerComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    HttpClientModule,
    NgbNavModule,
    SnotifyModule,
    GridModule,
    IntlModule,
    LabelModule,
    ForecastuiModule,
  ],
  providers: [
    NavigationItem,
    { provide: ErrorHandler, useClass: GlobalErrorHandler},
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
    { provide: RollbarService, useFactory: rollbarFactory },
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
    SnotifyService,
    { provide: WindowToken, useFactory: windowProvider }
  ],
 bootstrap: [AppComponent]
})
export class AppModule { }
